/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getprintManifest } from "../../../actionsMethods/manifestMethods";
import TableContent from "./TableContent";
import appLogo from "../../../assests/images/smcsLogo.svg";
import printLogo from "../../../assests/images/bluePrint.svg";
import locationLogo from "../../../assests/images/LocationIconFomManifest.svg";
import { Button, Col, Row, Table, Tooltip } from "antd";
import Moment from "react-moment";
import { camelCase } from "../../../utils";

import "./style.scss";

function printManifest() {
  const [apiData, setApiData] = useState([]);
  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const { fetching: loader1, result: packetAndShipmt } = useSelector(
    (state) => state.manifestReducer.getprintManifestReducer,
    shallowEqual
  );

  const history = useLocation();

  useEffect(() => {
    if (packetAndShipmt !== null) {
      setApiData(packetAndShipmt);
    }
  }, [loader1]);

  useEffect(() => {
    dispatch(getprintManifest(history?.state));
  }, [history]);

  function MyComponent(dateToFormat) {
    const toUpperCaseFilter = (d) => {
      return d.slice(0, 10);
    };
    return (
      <Moment filter={toUpperCaseFilter} format="DD/MM/YYYY">
        {dateToFormat}
      </Moment>
    );
  }

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <div className="container">
      <div className="container-header">Print Manifest </div>
      <div className="container-header-line"></div>
      <div className="print-btn">
        <Button onClick={handlePrint}>
          <img src={printLogo} />
          PRINT
        </Button>
      </div>
      <div className="container-flex p-2" ref={componentRef}>
        <div className="container-contain">
          <Row className="container-contain-div">
            <Col span={8} className="">
              <img src={appLogo} />
            </Col>
          </Row>
          <Row style={{ padding: "0 21px" }}>
            <Col lg={10}>
              <Address
                cpOrHub={"CP"}
                address={camelCase(apiData?.fromLocation)}
              />
            </Col>
            <Col lg={4}></Col>
            <Col lg={10}>
              <Address
                cpOrHub={"Hub"}
                address={camelCase(apiData?.toLocation)}
              />
            </Col>
          </Row>
          <Row className="container-contain-dateandtime">
            <Col lg={6}>
              Manifest ID : <span>{apiData?.manifestId}</span>
            </Col>
            <Col lg={5}>
              Date :{" "}
              <span className="container-contain-dateandtime-heading">
                {MyComponent(apiData?.createDate)}
              </span>
            </Col>
            <Col lg={4}>
              Time :{" "}
              <span className="container-contain-dateandtime-heading">
                {apiData?.createDate?.split(" ")[1]}
              </span>
            </Col>
            <Col lg={6}></Col>
          </Row>
          <div className="container-contain-table">
            <TableContent apiData={apiData} />
          </div>
        </div>
      </div>
    </div>
  );
}

const Address = ({ address, cpOrHub }) => {
  return (
    <div className="address">
      <div>
        <img src={locationLogo} />
        <span className="address-header">{`${cpOrHub} Address`}</span>
      </div>
      <div className="address-desc">{address}</div>
    </div>
  );
};

export default printManifest;
